export enum TypeReferences {
  General = 'collection_general',
  Wishlist = 'collection_wishlist',
}
